// extracted by mini-css-extract-plugin
export default {"cls1":"SnackBar-cls1_ESl","cls2":"SnackBar-cls2__u6 SnackBar-cls1_ESl"};